import { MAT_DATE_LOCALE, MatButtonModule, MatNativeDateModule } from '@angular/material';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorDialogComponent } from './components/dialog/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from './components/dialog/success-dialog/success-dialog.component';
import { ChamadoDelegatarioComponent } from './pages/chamado-delegatario/chamado-delegatario.component';
import { ConsultarChamadoComponent } from './pages/consultar-chamado/consultar-chamado.component';

import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy
} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { MatIconModule } from "@angular/material";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from "@angular/platform-browser";
import { ToasterModule } from "angular2-toaster";
import "hammerjs";
import { BlockUIModule } from "ng-block-ui";
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings
} from "ng-recaptcha";
import { NgxHmCarouselModule } from "ngx-hm-carousel";
import { NgxMaskModule } from "ngx-mask";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthGuard } from "./auth/_guards";
import { AuthInterceptor } from "./auth/_guards/auth.interceptor";
import { AuthModule } from "./auth/_guards/auth.module";
import { IdentityStorage } from "./auth/_models/identity.storage";
import { AuthenticationService } from "./auth/_services";
import { MensagemDialogComponent } from './components/dialog/mensagem-dialog/mensagem-dialog.component';
import { MaterialModule } from "./material.module";
import { BaseComponent } from "./pages/base/base.component";

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { ErrorPadraoDialogComponent } from './components/dialog/error-padrao-dialog/error-padrao-dialog.component';
import { CadastroCartaPrecatoria } from './pages/cadastro-distribuidor/cadastro-carta-precatoria';
import { ChamadoAdvogadoComponent } from "./pages/chamado-advogado/chamado-advogado.component";
import { ChamadoDelegatarioCadastroAcessoComponent } from './pages/chamado-delegatario-cadastro-acesso/chamado-delegatario-cadastro-acesso.component';
import { ChamadoDelegatarioErroInfoComponent } from './pages/chamado-delegatario-erro-info/chamado-delegatario-erro-info.component';
import { PageErrorComponent } from './pages/page-error/page-error.component';
import { FooterComponent } from "./pages/template/footer/footer.component";
import { HeaderComponent } from "./pages/template/header/header.component";
import { TribunalOrigemService } from './service/carta-precatoria/tribunal-origem.service';
import { PadraoService } from "./service/padrao/padrao.service";
import { UsuarioService } from "./service/usuario/usuario.service";

const globalSettings: RecaptchaSettings = {
  siteKey: "6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___"
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    BaseComponent,
    ConsultarChamadoComponent,
    ChamadoAdvogadoComponent,
    ChamadoDelegatarioComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    ErrorPadraoDialogComponent,
    MensagemDialogComponent,
    PageErrorComponent,
    CadastroCartaPrecatoria,
    MensagemDialogComponent,
    ChamadoDelegatarioErroInfoComponent,
    ChamadoDelegatarioCadastroAcessoComponent
  ],
  imports: [
    MatInputModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    BrowserModule,
    MatFormFieldModule,
    MaterialModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RecaptchaFormsModule,
    HttpModule,
    NgxMaskModule.forRoot(),
    BlockUIModule.forRoot(),
    ToasterModule.forRoot(),
    AuthModule,
    MatExpansionModule,
    MatProgressBarModule,
    NgxHmCarouselModule,
    RecaptchaModule.forRoot(),
    RouterModule.forRoot([
      { path: 'consulta-chamado', component: ConsultarChamadoComponent },
      { path: 'chamado-advogado', component: ChamadoAdvogadoComponent },
      { path: 'chamado-delegatario', component: ChamadoDelegatarioComponent },
      { path: 'cadastro-carta-precatoria', component: CadastroCartaPrecatoria }
    ])
  ],
  providers: [
    PadraoService,
    IdentityStorage,
    AuthGuard,
    AuthenticationService,
    UsuarioService,
    TribunalOrigemService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ],
  entryComponents: [SuccessDialogComponent, ErrorDialogComponent,ErrorPadraoDialogComponent,MensagemDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
